import { createSlice } from "@reduxjs/toolkit";

export const orderSlice = createSlice({
  name: "order",
  initialState: {
    isTaxable: false,
    createdFromOrderId: null,
    isHighPriority: false,
    voiceOrderId: null,
  },
  reducers: {
    updateOrderTaxableState: (state, action) => {
      const { payload: isTaxable } = action;
      return { ...state, isTaxable };
    },

    createdFromOrder: (state, action) => {
      return { ...state, ...action.payload };
    },

    updateOrderHighPriorityState: (state, action) => {
      const { payload: isHighPriority } = action;
      return { ...state, isHighPriority };
    },

    createdFromVoiceOrder: (state, action) => {
      return { ...state, ...action.payload };
    },

    updateOrderToInitial: () => {
      return {
        isTaxable: false,
        createdFromOrderId: null,
        isHighPriority: false,
        voiceOrderId: null,
      };
    },
  },
});

export const {
  updateOrderTaxableState,
  createdFromOrder,
  updateOrderHighPriorityState,
  updateOrderToInitial,
  createdFromVoiceOrder,
} = orderSlice.actions;

export default orderSlice.reducer;
